import React, { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import img1 from "../assets/images/1.jpg";

const Thumbnail = ({ driveId, itemId, title }) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [thumbnail, setThumbnail] = useState(null);
  const { ref, inView } = useInView({ triggerOnce: true });

  useEffect(() => {
  const fetchThumbnail = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}/presales/api/thumbnail?drive_id=${driveId}&item_id=${itemId}`
      )

      if (!res.ok) {
        console.error("API failed:", res.status);
        return;
      }

      const data = await res.json();
      setThumbnail(data.thumbnail_url);
    } catch (err) {
      console.error("Thumbnail error:", err);
    }
  };

  if (driveId && itemId) {
    fetchThumbnail();
  }
}, [driveId, itemId]);

  return (
    <img
      ref={ref}
      src={thumbnail || img1 }
      alt={title}
      className="card-img-top"
      loading="lazy"
      onError={(e) => (e.target.src = "img1")}
    />
  );
};

export default Thumbnail;